import { z } from 'zod';

export const bbox = z.object({
  west: z.number().min(-180).max(180),
  south: z.number().min(-90).max(90),
  east: z.number().min(-180).max(180),
  north: z.number().min(-90).max(90),
});
export type Bbox = z.infer<typeof bbox>;

export const downloadRegionRequest = z.object({
  bbox,
  zMin: z.number().int().min(0).max(20),
  zMax: z.number().int().min(0).max(20),
});
export type DownloadRegionRequest = z.infer<typeof downloadRegionRequest>;

export const downloadRegionResponse = z.object({
  token: z.string(),
  expiresAt: z.number().int(),
  tileBudget: z.number().int(),
});
export type DownloadRegionResponse = z.infer<typeof downloadRegionResponse>;
